export enum MenuPointUrl {
	USERS = '/users',
	CREATE_USER = '/users/create',
	MULTIPLE_ASSIGNMENT = '/users/assign',
	VEHICLES = '/vehicles',
	NOTIFICATIONS = '/notifications',
}
